import { AppBar, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	root: {
		boxShadow: 'none',
		background: theme.palette.blue.main,
	},
	toolbar: {
		display: 'flex',
		justifyContent: 'center',
	},
	logo: {
		width: '80px',
		height: '61.76px',
	},
}));

const GuestTopbar = () => {
	const classes = useStyles();

	return (
		<AppBar className={classes.root}>
			<Toolbar className={classes.toolbar}>
				<RouterLink to="/">
					<img alt="Logo" src="./images/logo.svg" className={classes.logo} />
				</RouterLink>
			</Toolbar>
		</AppBar>
	);
};

GuestTopbar.defaultProps = {
	profile: false,
};

export default GuestTopbar;
